import { queryOptions } from '@tanstack/react-query';
import type { AdminEventDto, AdminEventListQuery, AdminEventListResponse } from '@upme/contracts';
import { api } from '../../app/api-client';

export const eventsKey = ['admin', 'events'] as const;

export type EventListFilters = Omit<AdminEventListQuery, 'limit'> & { limit?: number };

function buildSearchParams(filters: EventListFilters): URLSearchParams {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v === undefined || v === null || v === '') continue;
    params.set(k, String(v));
  }
  return params;
}

export const listEventsOptions = (filters: EventListFilters = {}) =>
  queryOptions({
    queryKey: [...eventsKey, 'list', filters] as const,
    queryFn: () =>
      api.get('admin/events', { searchParams: buildSearchParams(filters) }).json<AdminEventListResponse>(),
    staleTime: 10_000,
  });

export const eventByIdOptions = (id: string) =>
  queryOptions({
    queryKey: [...eventsKey, id] as const,
    queryFn: () => api.get(`admin/events/${id}`).json<AdminEventDto>(),
  });
